import axios from 'axios'

class ReportService {
  async submitReport({ apiEndpoint, userInfo, bugReport, bugData }) {
    const reportData = {
      reportId: this.generateReportId(),
      timestamp: new Date().toISOString(),
      projectId: 'placedesenergies-frontend',
      userInfo,
      report: { ...bugReport },
      context: bugData.context,
      debugData: bugData.debugData,
      attachments: bugData.attachments
    }
    
    const response = await axios.post(apiEndpoint, reportData)

    return response
  }

  generateReportId() {
    return `bug_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  }
}

export default new ReportService()